module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado20.b897c1a2.svg";